import { createContext, useEffect, useState, useContext } from "react";
import { useSessionStorage } from "./useSession";
import axios from "axios";
import { toast } from "react-toastify";
import { decryptData } from "./Crypto";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useSessionStorage("token", null);
  const [isRemember, setIsRemember] = useState(false);
  const [user, setUser] = useState({});
  const userId = localStorage.getItem("userId");
  const email = localStorage.getItem("email");
  const [loadingUser, setLoadingUser] = useState(true);

  useEffect(() => {
    if (!token) {
      setLoadingUser(false);
      return;
    }

    axios
      .get(
        `${process.env.REACT_APP_BASE_URL}/deephire/api/v1/user/view/?id=${userId}`,
        {
          headers: {
            Authorization: `Bearer ${token?.token}`,
          },
        }
      )
      .then(function (response) {
        let resDecryptedData = decryptData(
          response?.data?.data,
          response?.config?.url
        );

        const data = resDecryptedData;
        console.log("data", data);
        const fullName = `${response?.data?.first_name} ${response?.data?.last_name}`;
        const userObj = {
          email: data?.email,
          name: fullName,
          firstName: data?.first_name,
          permission: data?.user_permissions,
          company_name: data?.company_name,
          company_country: data?.company_country,
          webhookUrl: data?.webhook_url,
          integrationType: data?.integration_type,
          domainWebhook: data?.domain_webhook_url,
          userType: data?.user_type_name,
          userId: data?.id,
          status: data?.status,
          userPrefrence: true,
          rememberMe: isRemember,
          profileImage: data?.profile_image,
          paginationPref: data?.user_pagination_preference,
          tour: data?.tour,
          rejectReason: data?.reject_reason,
          profileCompletion: data?.user_profile_completion,
          businessProfileCompletion: data?.business_profile_completion,
          isMainAdmin: data?.is_main_admin,
          cin_status: data?.cin_status,
          resume: data?.resume,
          is_audio_consent_done: data?.is_audio_consent_done,
          is_consent_image_done: data?.is_consent_image_done,
          linkedin_url: data?.linkedin_url,
          companyId: data?.company,
          application_count: data?.application_count,
          completed_interview_count: data?.completed_interview_count,
          remaining_interview_count: data?.remaining_interview_count,
          integrationType: data?.integration_type,
        };

        // Add recent job application details for candidate users
        if (
          data?.user_type_name === "Candidate" &&
          data?.applied_jobs?.length > 0
        ) {
          const recentApplication = data.applied_jobs[0];
          userObj.recentApplication = {
            jobId: recentApplication?.job_post?.id,
            companyName: recentApplication?.job_post?.company,
            jobTitle: recentApplication?.job_post?.title,
            applicationStatus: recentApplication?.application_status,
            appliedDate: recentApplication?.applied_date,
            isInterviewComplete: recentApplication?.is_interview_completed,
          };
        }

        setUser(userObj);
      })
      .catch(function (error) {
        if (error?.response?.status === 401) {
          toast.error(error?.response?.data.messages[0]?.message);
          logout();
        } else {
          toast.error(error?.response?.data?.message ?? error?.message);
        }
      })
      .finally(() => {
        setLoadingUser(false);
      }, [token]);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  const login = async (data) => {
    setLoadingUser(true);
    console.log(data);
    setIsRemember(data?.rememberMe);
    setToken({
      token: data?.token,
      refreshToken: data?.refreshToken,
    });

    // Create a complete user object with all necessary fields
    const userData = {
      email: data?.email,
      name: data?.name,
      permission: data?.permission,
      userType: data?.userType,
      userId: data?.userId,
      status: data?.status,
      rememberMe: data?.rememberMe,
      profileImage: data?.profileImage,
      paginationPref: data?.paginationPref,
      cin_status: data?.cin_status || "active",
      is_audio_consent_done: data?.is_audio_consent_done || false,
      resume: data?.resume || null,
      linkedin_url: data?.linkedin_url || null,
      recentApplication: data?.recentApplication || null,
      is_consent_image_done: data?.is_consent_image_done || false,
      is_audio_consent_done: data?.is_audio_consent_done || false,
      linkedin_url: data?.linkedin_url || null,
      resume: data?.resume || null,
      profileImage: data?.profileImage || null,
      paginationPref: data?.paginationPref || null,
      cin_status: data?.cin_status || "active",
      rememberMe: data?.rememberMe || false,
    };
    console.log("userData", userData);
    setUser(userData);
    setLoadingUser(false);
  };

  const logout = () => {
    setLoadingUser(true);
    const postData = {
      email: email,
    };

    axios
      .post(
        `${process.env.REACT_APP_BASE_URL}/deephire/api/v1/logout/`,
        postData,
        {
          headers: {
            Authorization: `Bearer ${token?.token}`,
          },
        }
      )
      .then(function (response) {
        let resDecryptedData = decryptData(
          response?.data?.data,
          response?.config?.url
        );

        const decryptedData = resDecryptedData?.data;

        toast.success("User logged out successfully");
        const data = decryptedData;
        setToken(null);
        setUser(null);
        window.localStorage.clear();
        // window.location.href = "/login";
      })
      .catch(function (error) {
        // Don't show error toast for 401 since it's an expected case during token expiration
        if (error?.response?.status === 401) {
          // toast.error(error?.response?.data?.message ?? error?.message);
          setToken(null);
          setUser(null);
          window.localStorage.clear();
          window.location.href = "/login";
        } else {
          // toast.error(error?.response?.data?.message ?? error?.message);
          window.location.href = "/login";
        }
      })
      .finally(() => {
        setLoadingUser(false);
        // Reset the logout flag from useAxios
        window.isLoggingOut = false;
      });
  };

  const IdleLogout = () => {
    setToken(null);
    setUser(null);
    window.localStorage.clear();
    window.location.href = "/login";
    setLoadingUser(false);
    toast.success("User logged out successfully");
  };
  const value = {
    user,
    setUser,
    token,
    setToken,
    login,
    logout,
    loadingUser,
    IdleLogout,
  };
  return (
    <AuthContext.Provider
      value={{ user, setUser, token, setToken, login, logout, IdleLogout }}>
      {children}
    </AuthContext.Provider>
  );
};

// const handleLogout = async () => {
//   const email = localStorage.getItem("email");
//   const tokenObject = JSON.parse(sessionStorage.getItem("token"));

//   const requestData = {
//     email: email,
//     token: storedToken.token,
//   };

//   try {
//     const response = await axios.post(
//       `${process.env.REACT_APP_BASE_URL}/guruji/api/v1/logout/`,
//       requestData,
//       {
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${token}`,
//         },
//       }
//     );

//     if (response.data.status) {

//     } else {
//       console.error("Server responded with an error:", response.data.message);
//     }
//   } catch (error) {
//     console.error("Error logging out:", error);
//   }
// };
